import { useEffect } from "react";
import { ToastContainer, ToastOptions } from "react-toastify";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useUpdateProgressSelector } from "userful-chronos-common-store/dist/videoengines";
import UpdateProgressToast from "./UpdateProgressToast";
import { useSourceAssetSelector } from "userful-chronos-common-store/dist/sourceassets";

const containerID = "UPDATE_PROGRESS_CONTAINER";
const toastID = "UPDATE_PROGRESS_TOAST";

const toastOptions: ToastOptions = {
    className: "notificationTostify",
    containerId: containerID,
    toastId: toastID,
    hideProgressBar: true,
};

const UpdateProgressContainer = () => {
    const { t } = useTranslation();
    const updateProgress = useUpdateProgressSelector((state) => state.updateProgressStore.updateStatus);
    const assets = useSourceAssetSelector((state) => state.assetStore.assets);

    useEffect(() => {
        if (updateProgress.status === "NONE") {
            if (toast.isActive(toastID)) {
                toast.dismiss(toastID);
            }
            return;
        }
        const hasBlackMagic = assets.findIndex((a) => a.type === "DECKLINK") >= 0;
        if (toast.isActive(toastID)) {
            toast.update(toastID, {
                render: <UpdateProgressToast updateProgress={updateProgress} hasBlackMagic={hasBlackMagic} />,
                containerId: containerID,
            });
        } else {
            toast.info(
                <UpdateProgressToast updateProgress={updateProgress} hasBlackMagic={hasBlackMagic} />,
                toastOptions,
            );
        }
    }, [updateProgress, assets]);

    return (
        <ToastContainer
            position="top-center"
            autoClose={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            containerId={containerID}
            className="customContainer"
            closeButton={<></>}
            icon={() => <></>}
        />
    );
};

export default UpdateProgressContainer;
